import React from "react";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";

/**
 * This component solves the issue with react-markdown v10+ not accepting className props
 * It provides a wrapper that can be used with styled-components or with regular className
 *
 * Usage with styled-components:
 * const MyStyledMarkdown = styled(StyledReactMarkdownWrapper)`
 *   p { color: red; }
 * `;
 *
 * <MyStyledMarkdown>{markdownContent}</MyStyledMarkdown>
 *
 * Usage with className:
 * <StyledReactMarkdown className="my-class">{markdownContent}</StyledReactMarkdown>
 */

// Base component that can be styled
export const StyledReactMarkdownWrapper = ({
  children,
  components,
  ...rest
}) => {
  return (
    <div {...rest}>
      <ReactMarkdown components={components}>{children}</ReactMarkdown>
    </div>
  );
};

// Pre-styled component for direct use
const StyledReactMarkdown = styled(StyledReactMarkdownWrapper)`
  /* Default styles for markdown content */
  p {
    margin-bottom: 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }

  ul,
  ol {
    margin-bottom: 1rem;
    padding-left: 2rem;
  }

  a {
    color: #0066cc;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  blockquote {
    border-left: 4px solid #ddd;
    padding-left: 1rem;
    margin-left: 0;
    color: #666;
  }

  code {
    background-color: #f5f5f5;
    padding: 0.2rem 0.4rem;
    border-radius: 3px;
    font-family: monospace;
  }

  pre {
    background-color: #f5f5f5;
    padding: 1rem;
    border-radius: 3px;
    overflow-x: auto;

    code {
      background-color: transparent;
      padding: 0;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 1rem;

    th,
    td {
      border: 1px solid #ddd;
      padding: 0.5rem;
    }

    th {
      background-color: #f5f5f5;
    }
  }
`;

export default StyledReactMarkdown;
